<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1 9.85156V12.8406C1 15.1381 2.8625 17.0006 5.16
              17.0006H12.84C15.1375 17.0006 17 15.1381 17 12.8406V9.85156"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M8.99961 9.85115V1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M13.7992 6.31069L8.99922 1L4.19922 6.31069"
    stroke="black"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
